module.exports = __webpack_public_path__ + "static/img/bestimade_ercode.91bb2f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bestimade_ercode.jpg
// module id = nnG7
// module chunks = 1 4